import { createVuetify } from 'vuetify';
import { aliases } from 'vuetify/iconsets/md'
import { fa } from 'vuetify/locale';
import icomoon from '@/components/icomoon.vue';
import momentJalali from '@date-io/jalaali';

const vuetify = createVuetify({
    defaults: {
        global: {
            density: 'compact',
        },
        VTextField: {
            variant: 'outlined',
            flat: true
        },
        VSelect: {
            variant: 'outlined',
            flat: true
        },
        VAutocomplete: {
            variant: 'outlined',
            clearOnSelect: true,
            flat: true
        },
        VCombobox: {
            variant: 'outlined',
            flat: true
        },
        VTextarea: {
            variant: 'outlined',
            flat: true
        },
        VBtn: {
            density: 'default',
            flat: true,
        },
        VBadge: {
            color: 'error'
        },
        VCard: {
            flat: true,
        },
        VToolbar: {
            flat: true,
            class: 'helpical-shadow',
        },
        VTable: {
            class: 'text-grey-darken-3'
        },
        VCheckbox: {
            color: 'secondary'
        },
        VRadioGroup: {
            color: 'secondary',
        },
        VRadio: {
            color: 'secondary',
        }
    },
    locale: {
        locale: 'fa',
        messages: { fa },
        rtl: { fa: true },
    },
    date: {
        adapter: momentJalali,
    },
    icons: {
        defaultSet: 'helpical',
        aliases,
        sets: {
            helpical: {
                component: icomoon
            },
        },
    },
    theme: {
        defaultTheme: 'helpical',
        variations: {
            colors: ['primary', 'secondary'],
            lighten: 4,
            darken: 4,
        },
        themes: {
            helpical: {
                dark: false,
                colors: {
                    primary: '#0D3B66',
                    secondary: '#2877DC',
                    success: '#34C38F',
                    error: '#F46A6A',
                    warning: '#F1B44C',
                    'on-background': '#606060'
                },
                variables: {
                    'theme-on-success': '#FFFFFF',
                    'theme-on-warning': '#FFFFFF',
                }
            }
        },
    },
    // display: {
    //     mobileBreakpoint: 'sm',
    //     thresholds: {
    //         xs: 0,
    //         sm: 600,
    //         md: 850,
    //         lg: 1100,
    //         xl: 1400,
    //     },
    // },
})

export default vuetify;
